import { Download, Upload, UserPlus } from "lucide-react";

export default function CustomerExportActions({ onImport, onExport, onNew }) {
  return (
    <div className="flex items-center gap-2">
      <button
        type="button"
        onClick={onImport}
        className="inline-flex items-center gap-2 rounded-lg border border-slate-200 bg-white px-3 py-2 text-sm font-medium text-slate-700 hover:bg-slate-50"
      >
        <Upload size={16} />
        Importeren
      </button>
      <button
        type="button"
        onClick={onExport}
        className="inline-flex items-center gap-2 rounded-lg border border-slate-200 bg-white px-3 py-2 text-sm font-medium text-slate-700 hover:bg-slate-50"
      >
        <Download size={16} />
        Exporteren
      </button>
      <button
        type="button"
        onClick={onNew}
        className="inline-flex items-center gap-2 rounded-lg border border-slate-900 bg-slate-900 px-3 py-2 text-sm font-medium text-white hover:bg-slate-800"
      >
        <UserPlus size={16} />
        Nieuwe klant
      </button>
    </div>
  );
}
